import { render, staticRenderFns } from "./ApuracaoContratoAcaoConcluirIndustria.vue?vue&type=template&id=5b31f440&"
import script from "./ApuracaoContratoAcaoConcluirIndustria.vue?vue&type=script&lang=js&"
export * from "./ApuracaoContratoAcaoConcluirIndustria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports